let form = null

const setForm = (data) => {
    form = data;
}

const getForm = () => {
    return form
}

export {
    setForm,
    getForm
}